import React, { useEffect, useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { ISearchPage } from "@/types/FmsTypes";
import { transPgToPagination } from "../../../../../base/app/appModel";
import { billService } from "../../../../../bill/BillService";
import { IAccountLogDetail, IAccountLogFields, IAccountLogSearch, IAccountLogSearchParam } from "../../../../AccountTypes";
import { useDetailModel } from "../detailModel";
import { accountService } from "../../../../AccountService";

export const useLogModel = createModel(function () {
    const initSearchParam: IAccountLogSearchParam = {};
    const initDataSource: IAccountLogDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IAccountLogSearchParam>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IAccountLogDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IAccountLogFields>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [openDrawerVisible, setOpenDrawerVisible] = useState(false);
    const [adjustDrawerVisible, setAdjustDrawerVisible] = useState(false);
    const [rechargeDrawerVisible, setRechargeDrawerVisible] = useState(false);
    const [transferDrawerVisble, setTransferDrawerVisble] = useState(false);
    const { customerCode } = useDetailModel();
    const [state, setstate] = useState(false)

    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
        setstate(!state)
    }


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IAccountLogFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        setPgCfg(initPgCfg)
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }
    const loadData = async (page: ISearchPage = initPgCfg) => {
        const searchParams: IAccountLogSearch = {
            ...searchParam,
            partnerCode: customerCode,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await accountService.logPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        clearSelectData();
    }


    return {
        /***field***/
        state,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        openDrawerVisible,
        adjustDrawerVisible,
        rechargeDrawerVisible,
        transferDrawerVisble,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setOpenDrawerVisible,
        setAdjustDrawerVisible,
        setRechargeDrawerVisible,
        setTransferDrawerVisble,
        onSearch,
        onReset,
        setSelectedData
    }
});
